import { render, staticRenderFns } from "./DigitalMaturity.vue?vue&type=template&id=1ec1fe8e&scoped=true&"
import script from "./DigitalMaturity.vue?vue&type=script&lang=js&"
export * from "./DigitalMaturity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec1fe8e",
  null
  
)

export default component.exports